import { setupNewRelic, track } from '$lib/helpers/newRelic';

setupNewRelic();

export const handleError = async ({ error, event, status, message }) => {
	track.exception(error, { event, status, message });
	return error;
};
